module.exports = __webpack_public_path__ + "static/media/green-box.2326388a.png";